import React, { useState, useEffect } from "react";
import { MdEdit, MdClear } from "react-icons/md";
import { useHistory } from "react-router";
import { toast } from "react-toastify";
import EnquiryService from "../../../Services/EnquiryService";
import { FaAngleUp, FaAngleDown } from "react-icons/fa";
import moment from "moment";
import { DeleteItem } from "../../../Components/Modal";
import Loader from "../../../Components/Loader";

export const FollowUp = () => {
  const history = useHistory();
  const [enquiryList, setEnquiryList] = useState();
  const [loader, setLoader] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [followUpdateStart, setFollowUpdateStart] = useState()
  const [followUpdateEnd, setFollowUpdateEnd] = useState()

  useEffect(() => {
    getFollowupList();
    // eslint-disable-next-line
  }, [followUpdateStart, followUpdateEnd]);

  const appendHandler = (event, key) => {
    // console.log(key)
    event.target.closest("tr").classList.toggle("showTr");
    let arry = [...enquiryList];

    // enquiryList.filter((item, ind) => {
    //   if (key === ind) {
    //     item.show = Boolean(!item.show)
    //   }
    // });
    // eslint-disable-next-line
    enquiryList.map((val, ind) => {
      if (key === ind) {
        val.show = Boolean(!val.show);
      }
    });

    setEnquiryList(arry);
  };

  // follow_up_date_start=2021-12-14&follow_up_date_end=2021-12-15

  const getFollowupList = (cancelled = 0) => {
    let param = {
      quote_status: "FOLLOWUP",
      cancelled: cancelled
    };
    if (followUpdateStart) {
      param["follow_up_date_start"] = followUpdateStart
    }
    if (followUpdateEnd) {
      param["follow_up_date_end"] = followUpdateEnd
    }
    EnquiryService.getEnquiryapi(param).then((result) => {
      if (result.status === true) {
        setLoader(false);

        let quoteArry = [];
        // eslint-disable-next-line
        result.data.map((val) => {
          val.show = false;
          quoteArry.push(val);
        });
        setEnquiryList(result.data);
      } else {
        setLoader(false);
      }
    });
  };

  const onModalSubmit = () => {
    let deleteData = {
      quote_token: openModal,
    };
    // console.log("deleteData ===> ", deleteData);
    EnquiryService.deleteEnquiry(deleteData).then((res) => {
      if (res.status === true) {
        getFollowupList();
        toast.success("Deleted Successfully");
        setOpenModal(false);
      } else {
        toast.error(res.message);
        setOpenModal(false);
      }
    });
  };

  function resetHandler() {
    setFollowUpdateStart("")
    setFollowUpdateEnd("")
  }

  return (
    <div className="row">
      <div className="col-lg-12">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-end mb-3 align-items-end">
              <div className="me-3">
                <label>Follow Up Start Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setFollowUpdateStart(e.target.value)}
                  value={followUpdateStart}
                />
              </div>

              <div className="me-3">
                <label>Follow Up End Date</label>
                <input
                  type="date"
                  className="form-control"
                  onChange={(e) => setFollowUpdateEnd(e.target.value)}
                  value={followUpdateEnd}
                />
              </div>
              <div className="me-3">
                <button className="btn btn-primary w-sm waves-effect waves-light" onClick={() => resetHandler()}>
                  Reset
                </button>
              </div>


              <button
                className="btn btn-warning w-sm waves-effect waves-light mx-3"
                onClick={() => getFollowupList(0)}
              >
                Show Follow UP
              </button>

              <button
                className="btn btn-warning w-sm waves-effect waves-light mx-3"
                onClick={() => getFollowupList(1)}
              >
                Show Cancelled Follow UP
              </button>

            </div>

            <div className="table-responsive">
              <table className="table table-centered table-nowrap mb-0">
                <thead className="table-light">
                  <tr>
                    <th rowSpan="2">#</th>
                    <th rowSpan="2">Enquiery ID</th>
                    <th rowSpan="2">
                      Customer <br /> Name
                    </th>
                    <th rowSpan="2"> Mobile No.</th>
                    <th rowSpan="2">Inquiry Date</th>
                    <th rowSpan="2">
                      Quotation <br /> No.
                    </th>
                    <th rowSpan="2">
                      Retailer <br /> Name
                    </th>
                    <th rowSpan="2">Destination</th>
                    <th colspan="3" className="splitting_tr_up">
                      Cargo Details
                    </th>
                    {/* <th rowSpan="2" className="text-center">
                        Get Quotes
                      </th> */}
                    <th rowSpan="2" className="text-center">
                      Action
                    </th>
                  </tr>
                  <tr className="splittingCol">
                    <td>
                      No. of <br /> Packages
                    </td>
                    <td>
                      Total <br /> Volume
                    </td>
                    <td>
                      Total <br /> Weight
                    </td>
                  </tr>
                </thead>

                <tbody>
                  {enquiryList &&
                    enquiryList.map((item, key) => {
                      return (
                        <>
                          <tr className="parentTr">
                            <td>
                              {item.quotes.length > 1 ? (
                                <button
                                  className="btn btn-primary p-1 px-2"
                                  type="button"
                                  onClick={(event) => appendHandler(event, key)}
                                >
                                  {item.show === false ? (
                                    <FaAngleUp />
                                  ) : (
                                    <FaAngleDown />
                                  )}{" "}
                                  {item.quotes.length}
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary p-1 px-2"
                                  type="button"
                                >
                                  {key + 1}
                                </button>
                              )}
                            </td>
                            <td>{item.quotes[0]._id}</td>
                            <td>
                              {item.quotes[0]?.user_detail && item.quotes[0].user_detail.user_full_name ||
                                "NA"}
                            </td>

                            <td>
                              {item.quotes[0]?.user_detail && item.quotes[0].user_detail?.user_phone_number}
                            </td>

                            <td>
                              {moment(item.quotes[0].created_at).format(
                                "YYYY-MM-DD"
                              )}
                            </td>
                            <td>{item.quotes[0].quote_token}</td>

                            <td>
                              {(item.quotes[0].general_details &&
                                item.quotes[0].general_details.retailer_name) ||
                                "NA"}
                            </td>

                            <td>
                              {item.quotes[0].quote_courier.length > 0
                                ? item.quotes[0].quote_courier.map((list) => {
                                  return list.request_data.destination_city;
                                })
                                : item.quotes[0].quote_air.length > 0
                                  ? item.quotes[0].quote_air.map((list) => {
                                    return list.request_data.destination_city;
                                  })
                                  : item.quotes[0].quote_sea.length > 0
                                    ? item.quotes[0].quote_air.map((list) => {
                                      return list.request_data.destination_city;
                                    })
                                    : item.quotes[0].quote_land.length > 0
                                      ? item.quotes[0].quote_land.map((list) => {
                                        return list.request_data.destination_city;
                                      })
                                      : item.quotes[0].quote_land.map((list) => {
                                        return list.request_data.destination_city;
                                      })}
                            </td>

                            <td>
                              {item.quotes[0].quote_courier.length > 0
                                ? item.quotes[0].quote_courier.map((list) => {
                                  return list.request_data.number_of_packages;
                                })
                                : item.quotes[0].quote_air.length > 0
                                  ? item.quotes[0].quote_air.map((list) => {
                                    return list.request_data.number_of_packages;
                                  })
                                  : item.quotes[0].quote_sea.length > 0
                                    ? item.quotes[0].quote_air.map((list) => {
                                      return list.request_data.number_of_packages;
                                    })
                                    : item.quotes[0].quote_land.length > 0
                                      ? item.quotes[0].quote_land.map((list) => {
                                        return list.request_data.number_of_packages;
                                      })
                                      : item.quotes[0].quote_land.map((list) => {
                                        return list.request_data.number_of_packages;
                                      })}
                            </td>
                            <td>
                              {item.quotes[0].quote_courier.length > 0
                                ? item.quotes[0].quote_courier.map((list) => {
                                  return list.request_data.volume;
                                })
                                : item.quotes[0].quote_air.length > 0
                                  ? item.quotes[0].quote_air.map((list) => {
                                    return list.request_data.volume;
                                  })
                                  : item.quotes[0].quote_sea.length > 0
                                    ? item.quotes[0].quote_air.map((list) => {
                                      return list.request_data.volume;
                                    })
                                    : item.quotes[0].quote_land.length > 0
                                      ? item.quotes[0].quote_land.map((list) => {
                                        return list.request_data.volume;
                                      })
                                      : item.quotes[0].quote_land.map((list) => {
                                        return list.request_data.volume;
                                      })}
                            </td>

                            <td>
                              {item.quotes[0].quote_courier.length > 0
                                ? item.quotes[0].quote_courier.map((list) => {
                                  return list.request_data.weight;
                                })
                                : item.quotes[0].quote_air.length > 0
                                  ? item.quotes[0].quote_air.map((list) => {
                                    return list.request_data.weight;
                                  })
                                  : item.quotes[0].quote_sea.length > 0
                                    ? item.quotes[0].quote_air.map((list) => {
                                      return list.request_data.weight;
                                    })
                                    : item.quotes[0].quote_land.length > 0
                                      ? item.quotes[0].quote_land.map((list) => {
                                        return list.request_data.weight;
                                      })
                                      : item.quotes[0].quote_land.map((list) => {
                                        return list.request_data.weight;
                                      })}
                            </td>

                            <td>
                              <MdEdit
                                className="pointer"
                                color="#0323fe"
                                size="25px"
                                onClick={() =>
                                  history.push(
                                    "/edit-enquiry?id=" + item.quotes[0]._id,
                                    {quote_token: item.quotes[0]?.quote_token, quote_status:"FOLLOWUP"}
                                  )
                                }
                              />
                              {/* <MdDeleteForever
                                className="pointer"
                                color="red"
                                size="25px"
                                onClick={() =>
                                  setOpenModal(item.quotes[0].quote_token)
                                }
                              /> */}
                              <MdClear
                                className="pointer"
                                color="red"
                                size="25px"
                                onClick={() =>
                                  setOpenModal(item.quotes[0].quote_token)
                                }
                              />
                              {/* <MdVisibility
                                  className="pointer"
                                  onClick={() => history.push("enquiry-details")}
                                  onClick={() =>
                                    history.push(
                                      "/enquiry-details?id=" + item._id.user_id,
                                      item
                                    )
                                  }
                                  color="#0323fe"
                                  size="25px"
                                /> */}
                            </td>
                          </tr>


                          <tr>
                            <td colSpan="13">
                              <table className="table table-centered table-nowrap mb-0">
                                <thead className="table-light">
                                  <tr>
                                    <th rowSpan="2">#</th>
                                    <th rowSpan="2">Enquiery ID</th>
                                    <th rowSpan="2">
                                      Customer <br /> Name
                                    </th>
                                    <th rowSpan="2"> Mobile No.</th>
                                    <th rowSpan="2">Inquiry Date</th>
                                    <th rowSpan="2">
                                      Quotation <br /> No.
                                    </th>
                                    <th rowSpan="2">
                                      Retailer <br /> Name
                                    </th>
                                    <th rowSpan="2">Destination</th>
                                    <th
                                      colspan="3"
                                      className="splitting_tr_up"
                                    >
                                      Cargo Details
                                    </th>
                                    <th rowSpan="2" className="text-center">
                                      Get Quotes
                                    </th>
                                    <th rowSpan="2" className="text-center">
                                      Action
                                    </th>
                                  </tr>
                                  <tr className="splittingCol">
                                    <td>
                                      No. of <br /> Packages
                                    </td>
                                    <td>
                                      Total <br /> Volume
                                    </td>
                                    <td>
                                      Total <br /> Weight
                                    </td>
                                  </tr>
                                </thead>
                                <tbody>
                                  {item.quotes.map((val, ind) => {
                                    return (
                                      <tr>
                                        <td>{ind + 1}</td>
                                        <td>{val._id}</td>
                                        <td>
                                          {val?.user_detail?.user_full_name ||
                                            "NA"}
                                        </td>

                                        <td>
                                          {val?.user_detail?.user_phone_number}
                                        </td>

                                        <td>
                                          {moment(val.created_at).format(
                                            "YYYY-MM-DD"
                                          )}
                                        </td>
                                        <td>{val.quote_token || "NA"}</td>

                                        {/* <td>NA</td> */}
                                        <td>
                                          {(val.general_details &&
                                            val.general_details
                                              .retailer_name) ||
                                            "NA"}
                                        </td>

                                        <td>
                                          {val.quote_courier.length > 0
                                            ? val.quote_courier.map(
                                              (list) => {
                                                return list.request_data
                                                  .destination_city;
                                              }
                                            )
                                            : val.quote_air.length > 0
                                              ? val.quote_air.map((list) => {
                                                return list.request_data
                                                  .destination_city;
                                              })
                                              : val.quote_sea.length > 0
                                                ? val.quote_air.map((list) => {
                                                  return list.request_data
                                                    .destination_city;
                                                })
                                                : val.quote_land.length > 0
                                                  ? val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .destination_city;
                                                  })
                                                  : val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .destination_city;
                                                  })}
                                        </td>

                                        <td>
                                          {val.quote_courier.length > 0
                                            ? val.quote_courier.map(
                                              (list) => {
                                                return list.request_data
                                                  .number_of_packages;
                                              }
                                            )
                                            : val.quote_air.length > 0
                                              ? val.quote_air.map((list) => {
                                                return list.request_data
                                                  .number_of_packages;
                                              })
                                              : val.quote_sea.length > 0
                                                ? val.quote_air.map((list) => {
                                                  return list.request_data
                                                    .number_of_packages;
                                                })
                                                : val.quote_land.length > 0
                                                  ? val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .number_of_packages;
                                                  })
                                                  : val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .number_of_packages;
                                                  })}
                                        </td>
                                        <td>
                                          {val.quote_courier.length > 0
                                            ? val.quote_courier.map(
                                              (list) => {
                                                return list.request_data
                                                  .volume;
                                              }
                                            )
                                            : val.quote_air.length > 0
                                              ? val.quote_air.map((list) => {
                                                return list.request_data
                                                  .volume;
                                              })
                                              : val.quote_sea.length > 0
                                                ? val.quote_air.map((list) => {
                                                  return list.request_data
                                                    .volume;
                                                })
                                                : val.quote_land.length > 0
                                                  ? val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .volume;
                                                  })
                                                  : val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .volume;
                                                  })}
                                        </td>

                                        <td>
                                          {val.quote_courier.length > 0
                                            ? val.quote_courier.map(
                                              (list) => {
                                                return list.request_data
                                                  .weight;
                                              }
                                            )
                                            : val.quote_air.length > 0
                                              ? val.quote_air.map((list) => {
                                                return list.request_data
                                                  .weight;
                                              })
                                              : val.quote_sea.length > 0
                                                ? val.quote_air.map((list) => {
                                                  return list.request_data
                                                    .weight;
                                                })
                                                : val.quote_land.length > 0
                                                  ? val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .weight;
                                                  })
                                                  : val.quote_land.map((list) => {
                                                    return list.request_data
                                                      .weight;
                                                  })}
                                        </td>

                                        <td>
                                          <MdEdit
                                            className="pointer"
                                            onClick={() =>
                                              history.push(
                                                "/edit-enquiry?id=" + val._id,
                                                val?.quote_token
                                              )
                                            }
                                            color="#0323fe"
                                            size="25px"
                                          />

                                          {
                                            val.is_cancel !== 1 && <MdClear
                                              className="pointer"
                                              color="red"
                                              size="25px"
                                              onClick={() =>
                                                setOpenModal(val.quote_token)
                                              }
                                            />
                                          }

                                          {/* <MdDeleteForever
                                            className="pointer"
                                            color="red"
                                            size="25px"
                                            onClick={() =>
                                              setOpenModal(val?.quote_token)
                                            }
                                          /> */}

                                          {/* <MdVisibility
                                              className="pointer"
                                              onClick={() =>
                                                history.push("enquiry-details")
                                              }
                                              color="#0323fe"
                                              size="25px"
                                            /> */}
                                        </td>
                                      </tr>
                                    );
                                  })}
                                </tbody>
                              </table>
                            </td>
                          </tr>

                        </>
                      );
                    })}
                </tbody>
              </table>
              {enquiryList && enquiryList.length <= 0 && !loader && (
                <div className="text-center w-100 bg-warning my-5">
                  <h6 className="py-2"> list not available </h6>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      <Loader isShow={loader} />
      {Boolean(openModal) && (
        <DeleteItem
          isOpen={Boolean(openModal)}
          title="Delete Enquiry"
          message={`Are you sure want to delete?`}
          onSubmitEvent={() => onModalSubmit()}
          handleClose={() => setOpenModal(false)}
        />
      )}
    </div>
  );
};
